import { Channel, Movie, Series, EPGProgram, UserProfile, PlaylistSource, ParentalControlConfig, AppSettings } from '../types/iptv';

// Canais Oficiais do Sistema (Inicialmente vazio - sem listas pré-carregadas)
export const SYSTEM_DEFAULT_CHANNELS: Channel[] = [];

// Catálogo VOD de Filmes do Sistema (Inicialmente vazio)
export const SYSTEM_DEFAULT_MOVIES: Movie[] = [];

// Catálogo de Séries do Sistema (Inicialmente vazio)
export const SYSTEM_DEFAULT_SERIES: Series[] = [];

// Grade Inicial de Canais Importados
export const INITIAL_CHANNELS: Channel[] = [];

// Catálogo VOD de Filmes
export const INITIAL_MOVIES: Movie[] = [];

// Grade de Séries
export const INITIAL_SERIES: Series[] = [];

// Helper to generate live EPG programs for channels
export function generateLiveEPG(_channels: Channel[] = []): Record<string, EPGProgram[]> {
  // Retorna vazio por padrão para não injetar programação genérica repetida.
  // Apenas canais com dados reais de EPG (Xtream / XMLTV) exibirão o guia.
  return {};
}

export const INITIAL_PROFILES: UserProfile[] = [
  {
    id: 'prof-1',
    name: 'Master',
    avatar: '👑',
    isMaster: true,
    isKids: false,
    hasPin: false,
    pin: '',
    color: '#f59e0b',
    favorites: [],
    watchHistory: [],
    parentalSettings: {
      maxRating: '18',
      blockedCategories: [],
    }
  }
];

export const INITIAL_PLAYLISTS: PlaylistSource[] = [];

export const INITIAL_PARENTAL_CONFIG: ParentalControlConfig = {
  masterPin: '',
  isLockedByDefault: false,
  blockedCategories: [],
  allowedMaxAgeRating: '18',
  adultContentHidden: false,
  requirePinForPurchasesOrSettings: false,
};

export const INITIAL_SETTINGS: AppSettings = {
  aspectRatio: '16:9',
  hardwareAcceleration: true,
  autoPlayNext: true,
  bufferSizeSeconds: 15,
  subtitleSize: 'medium',
  tvRemoteEnabled: true,
  remoteOverlayVisible: false,
  uiScale: 'standard',
  preferredQuality: 'auto',
  volumeBooster: true,
  audioLanguage: 'pt-BR',
  fastZappingEnabled: true,
  streamProxyEnabled: true,
  showToastNotifications: false,
  showTelemetryButton: false,
  showFullscreenButton: false,
  showCastButton: true,
  showGridEpg: true,
};

// Sequência Canônica Oficial das Categorias de Canais do Banco / Gerenciador (#1 a #54)
export const DEFAULT_CANONICAL_LIVE_CATEGORIES: string[] = [
  'CANAIS | FILMES E SERIES',
  'CANAIS | DOCUMENTARIO',
  'CANAIS | TELECINE',
  'CANAIS | HBO',
  'CANAIS | CINE SKY',
  'CANAIS | INFANTIL',
  'CANAIS | PREMIERE',
  'CANAIS | SPORTV',
  'CANAIS | ESPN',
  'CANAIS | ESPORTE',
  'CANAIS | VARIEDADES',
  'CANAIS | NOTICIAS',
  'CANAIS | GLOBO SUL',
  'CANAIS | GLOBO SUDESTE',
  'CANAIS | GLOBO NORTE',
  'CANAIS | GLOBO NORDESTE',
  'CANAIS | GLOBO CENTRO-OESTE',
  'CANAIS | BAND',
  'CANAIS | RECORD',
  'CANAIS | SBT',
  'CANAIS | ABERTOS',
  'CANAIS | RELIGIOSO',
  'CANAIS | UHD 4K - H265',
  'CANAIS | HBO MAX CHAMPIONS LEAGUE',
  'CANAIS | ESPORTES PPV',
  'CANAIS | PARAMOUNT +',
  'CANAIS | PRIME VIDEO',
  'CANAIS | DISNEY+',
  'CANAIS | TABELA DE JOGOS',
  'CANAIS | INTERNACIONAL PT',
  'CANAIS | INTERNACIONAL US',
  'CANAIS | INTERNACIONAIS FUTEBOL PPV',
  'CANAIS | INTERNACIONAIS EVENTOS PPV',
  'CANAIS | 24H ⏰ Séries',
  'CANAIS | 24H ✝️ Caminho da Fé',
  'CANAIS | 24H ⏰ Desenhos',
  'CANAIS | 24H ⏰ Animes',
  'CANAIS | 24H ⏰ Heróis Sem Limites (Marvel & DC)',
  'CANAIS | 24H ⏰ Doramas',
  'CANAIS | 24H ⏰ Comedia',
  'CANAIS | 24H ⏰ Discovery+',
  'CANAIS | 24H ⏰ Bíblicos',
  'CANAIS | 24H ⏰Cinema',
  'CANAIS | 24H ⏰ Terror',
  'CANAIS | 24H ⏰ Super Sentai',
  'CANAIS | 24H ⏰ Lendas Do Cinema',
  'CANAIS | 24H ⏰ Shows',
  'CANAIS | 24H ⏰ Musicas',
  'CANAIS | BARRETOS',
  'CANAIS | XXX ADULTOS',
  'CANAIS | XXX ADULTOS PREMIUM',
  'Series | Amazon Prime',
  'Series | Discovery Plus',
  'Series | Apple TV Plus',
];

// Sequência Canônica Oficial das Categorias de Filmes do Banco / Gerenciador (#1 a #27)
export const DEFAULT_CANONICAL_MOVIE_CATEGORIES: string[] = [
  'Filmes | Lançamentos (2026)',
  'Filmes | Ação',
  'Filmes | Drama',
  'Filmes | Comédia',
  'Filmes | Guerra',
  'Filmes | Terror',
  'Filmes | Romance',
  'Filmes | Fantasia',
  'Filmes | Aventura',
  'Filmes | Crime',
  'Filmes | Faroeste',
  'Filmes | Família',
  'Filmes | Animação / Infantil',
  'Filmes | Documentarios',
  'Filmes | Ficção',
  'Filmes | Suspense',
  'Filmes | Shows',
  'Filmes | Nacionais',
  'Filmes | Religiosos',
  'Filmes | Stand UP',
  'Filmes | ShortDramas',
  'Filmes | Legendados',
  'Filmes | Animes',
  'Filmes | Cinema FUSION',
  'Filmes | Cinema',
  'Filmes | 4K',
  'Filmes | XXX Adultos',
];

// Sequência Canônica Oficial das Categorias de Séries do Banco / Gerenciador (#1 a #26)
export const DEFAULT_CANONICAL_SERIES_CATEGORIES: string[] = [
  'Series | Netflix',
  'Series | Amazon Prime',
  'Series | Disney Plus',
  'Series | Apple TV Plus',
  'Series | Paramount',
  'Series | Max',
  'Series | DirecTV',
  'Series | Legendadas',
  'Series | Programas de TV',
  'Series | Crunchyroll',
  'Series | Claro Video',
  'Series | Brasil Paralelo',
  'Series | SBT',
  'Series | Dorama',
  'Series | Novelas Turcas',
  'Series | Treine em Casa',
  'Series | Discovery Plus',
  'Series | Outras',
  'Series | PlutoTV',
  'Series | Lionsgate',
  'Series | Univer',
  'Series | AMC Plus',
  'Series | Globoplay',
  'Series | Funimation Now',
  'Series | Star Plus',
  'Series | Novelas',
];

